module.exports = __webpack_public_path__ + "assets/5b20aa45fadf536406ab421bd35beb4f.png";